export const GET_NAME = "Verify A/C No";
export const RE_CHECK = "RE-Verify A/C";
export const EMPTY = "";
export const SIGN_IN_URL = "/login";
export const UNAUTHORISED_CODE = "403";
export const UNAUTHORISED_CODE_401 = "401";
// export const BIOMETRIC_CAPTURE_API = aepsConfig.captureUrl;  //"https://127.0.0.1:11100/rd/capture";
// export const BIOMETRIC_CAPTURE_XML_DATA = aepsConfig.xmlData;// '<?xml version="1.0"?> <PidOptions ver="1.0"> <Opts fCount="1" fType="2" iCount="0" pCount="0" pgCount="2" format="0" pidVer="2.0" timeout="10000" pTimeout="20000" posh="UNKNOWN" env="P" /> <CustOpts><Param name="mantrakey" value="" /></CustOpts> </PidOptions>';

export const BIOMETRIC_DEVICE_INFO = "https://127.0.0.1:11100/rd/info";
export const FINO_MERCHANT_ID_INITIAL = "SRPFI";

export const LIST_DEMO_ALLOWED_USERS = "/admin/demoAllowed/list";
export const SAVE_DEMO_ALLOWED_USER = "/admin/demoAllowed/save";
export const REMOVE_DEMO_ALLOWED_USER = "/admin/demoAllowed/remove";


export const LEDGER_CORRECT_API = "/debug/modifyLedger2";
export const GET_TRANSACTION_ID = "/getRequestId";
export const APP_INFO = "APP_INFO";
export const USER_ROLE = "/role";
export const APP_INFO_URL = "/appinfo";
export const DMT_SETTING_URL = "/dmtSetting";
export const UTILITY_OFFLINE_PAYMENT_TAB = "UTILITY_OFFLINE_PAYMENT_TAB";

export const POST_GET_WALLET_BALANCE = "/users/getWalletBalance";
export const MOBILE_SEND_OTP = "/users/mobileNumber";
export const MOBILE_VERFIY_SEND = "/users/mobileNumberSend";
export const MOBILE_SEND_VERFIY = "/users/mobileNumberVerify";
export const GET_MYPROFILE = "/users/getprofile";
export const PARTNER_REGISTER = "/users/customer/register";

export const USER_BLOCK_UNBLOCK = "/users/block-unblock";
export const USER_BLOCK_LOG     = "/users/block-log";
export const USER_BLOCK_LOG_ALL = "/users/block-log-all";
export const USER_VERIFY_MPIN = "/users/verify-mpin";


export const CHANGE_PASSWORD = "/users/changepassword";

export const LIST_ALL_USERS = "/admin/getAllUsers";
export const LIST_ALL_USER = "/admin/getAllUser";
export const LIST_ACTIVE_USERS = "/admin/listActiveUsers";

export const UPDATE_NEW_PASSWORD = "/users/updateNewPasswordSendOTP";
export const UPDATE_NEW_PASSWORD_SAVE = "/users/updateNewPasswordSave";

export const FORGET_PASSWORD = "/users/forgetpassword";
export const FORGET_USERID = "/users/forgetuserid";
export const FORGET_PASSWORD_MOBILE_NUMBER = "/users/forgetpasswordmobilenumber";
export const STATE_API = "/prepaid/state";
export const KYC_UPDATE = "/users/KYCUpdate";
export const ADMIN_ACCEPT_PROFILE = "/admin/acceptProfile";
export const UPDATE_USER_PROFILE = "/users/updateprofile";
export const CREATE_ALL_TYPE_USERS = "/users/createUser";
export const CREATE_USERS_STAFF = "/users/createStaff";
export const CREATE_USER_MEMBER = '/users/createMember';
export const VERIFY_USER = '/users/getPan360';
export const PAN_VERIFICATION = '/users/getPanData';
export const GET_PARENT_PROFILE = "/users/getParentProfile"
export const POST_OPERATIVE_WALLET_RECHARGE = "/admin/oprativeBalanceRecharge"
export const GET_ADMIN_DASHBOARD_DATA = "/admin/getAdminDashboardData"
export const GET_MERCHANT_WALLET_BALANCE = "/admin/wallet/marchantBalance";
export const USER_BLOCKED_LIST = "/users/blocked-list";


export const POST_USER_CONTROL_STATUS = "/users/userControlStatus";

export const UPLOAD_FILE = "/upload-file";
export const UPLOAD_IMAGE_FILE = "/upload-image-file";
export const UPLOAD_SHOP_IMAGE_FILE = "/upload-shop-image-file";
export const UPLOAD_AEPS_IMAGE_FILE = "/upload-aeps-image-file";

export const POST_AEPS_TRANSACTION_INVOICE = "/aeps/transactionInvoice";

export const MOBILE_RECHARGE_OPERATORS = "/prepaid/mobile-operators";
export const MOBILE_RECHARGE_VIEW_PLAN = "/prepaid/mobile-recharge-viewplan";
export const MOBILE_RECHARGE_BESTOFFER = "/prepaid/mobile-recharge-bestoffer";
export const MOBILE_RECHARGE_PAYMENT = "/prepaid/mobile-recharge-payment";
export const MOBILE_RECHARGE_REPORT = "/prepaid/mobile-recharge-report";

export const DTH_PROVIDERS = "/prepaid/dth-providers";
export const DTH_CUSTOMER_INFO = "/prepaid/dth-customer-info";
export const DTH_BEST_OFFER = "/prepaid/dth-best-offer";
export const DTH_HEAVY_REFRESH = "/prepaid/dth-heavy-refresh";
export const DTH_RECHARGE_PAYMENT = "/prepaid/dth-recharge-payment";
export const DTH_RECHARGE_REPORT = "/prepaid/dth-recharge-report";


//BBPS
export const BBPS_BILLER_CATEGORY = '/bbps/getAllBillerCategory';
export const BBPS_ELETRICITY_OPERATORS = "/bbps/getBillerByBillerCategory";
export const BBPS_POST_BILL_FETCH_REQUEST = "/bbps/postBillFetchRequest";
export const BBPS_POST_BILL_PAYMENT_REQUEST = "/bbps/postBillPaymentRequest";
export const BBPS_POST_BILL_PAYMENT_STATUS = "/bbps/postBillPaymentStatus";
export const BBPS_POST_BILL_PAYMENT_HISTORY = "/bbps/getBbpsTransactionHistory";

export const ELETRICITY_OPERATORS = "/payment/eletricity-operators";
export const ELETRICITY_VIEW_BILL = "/payment/eletricity-view-bill";
export const ELETRICITY_BILL_PAYMENT = "/payment/eletricity-bill-payment";
export const ELETRICITY_BILL_PAYMENT_REPORT = "/payment/eletricity-bill-payment-report";

//Utility2.0
export const ELETRICITY_VIEW_BILL2 = "/payment/eletricity-view-bill2";
export const ELETRICITY_BILL_PAYMENT2 = "/payment/eletricity-bill-payment2";
export const ELETRICITY_BILL_PAYMENT_REPORT2 = "/payment/eletricity-bill-payment-report2";

export const WATER_OPERATORS = "/payment/water-operators";
export const WATER_VIEW_BILL = "/payment/water-view-bill";
export const WATER_BILL_PAYMENT = "/payment/water-bill-payment";
export const WATER_BILL_PAYMENT_REPORT = "/payment/water-bill-payment-report";

export const GAS_OPERATORS = "/payment/gas-operators";
export const GAS_VIEW_BILL = "/payment/gas-view-bill";
export const GAS_BILL_PAYMENT = "/payment/gas-bill-payment";
export const GAS_BILL_PAYMENT_REPORT = "/payment/gas-bill-payment-report";

export const INSURANCE_OPERATORS = "/payment/insurance-operators";
export const INSURANCE_VIEW_BILL = "/payment/insurance-view-bill";
export const INSURANCE_BILL_PAYMENT = "/payment/insurance-bill-payment";
export const INSURANCE_BILL_PAYMENT_REPORT = "/payment/insurance-bill-payment-report";

export const ADMIN_ALL_MAKER_FUND_REQUEST = "/admin/getAllAdminMakerFundRequest";
export const ADMIN_ALL_CHEKER_FUND_REQUEST = "/admin/getAllAdminChekerFundRequest";
export const ADMIN_FUND_REQUEST_STATUS_CHANGE_REQUEST = "/admin/fundRequestApproveOrReject";
export const ADMIN_UTILITY_PAYMENT_OFFLINE_STATUS_CHANGE_REQUEST = "/admin/utilityPaymentOfflineApproveOrReject";
export const ADMIN_DAILY_TRANSACTION_REPORT = "/admin/getDailyTransactionReport";
export const ADMIN_AEPS_LOGIN_REPORT = "/admin/getAepsLoginReport";

export const ADMIN_MAKER_UTILITY_PAYMENT_OFFLINE = "/admin/getUtilityPaymentOfflineMaker";
export const ADMIN_APPROVE_UTILITY_PAYMENT_OFFLINE = "/admin/getUtilityPaymentOfflineApprove";

export const GET_PARTNER_INFO = "/users/getPartnerInfo";
export const ADMIN_GET_ALL_APPROVED_EXPORT_USERS = "/admin/getAllApprovedUserExport";
export const ADMIN_GET_ALL_APPROVED_USERS = "/admin/getAllApprovedUser";

export const GET_PARENT_ROLES = '/admin/get-parent-roles';
export const GET_USERS_BY_ROLE = '/admin/get-users-by-role';
export const UPDATE_USER_ROLE_PARENT = '/admin/update-user-role-parent';
export const GET_SUPERIOR_ROLES = '/admin/role/superior';


// export const ADMIN_GET_ALL_EKYC_APPROVED_USERS = "/admin/getAllEKycApprovedUser";
export const ADMIN_AADHAR_PENDING_KYC_USERS = "/admin/getUsersAadhaarPending";
export const ADMIN_GET_ALL_KYC_PENDING_USERS = "/admin/getAllPendingKycUser";
export const GST_IN_VERIFY = "/users/gstInVerify";
export const PANCARD_VERIFY = "/users/pancardVerify";
export const JOIN_US_PANCARD_VERIFY = "/users/joinUsPancardVerify";
export const CREATE_USER_PANCARD_VERIFY = "/users/createUserPancardVerify";
export const AADHARCARD_OTP_VERIFY = "/users/aadharcardOTPVerify";
export const CREATE_USER_AADHARCARD_VERIFY = "/users/aadharcardCreateUserVerify";
export const CREATE_USER_AADHARCARD_OTP_VERIFY = "/users/aadharcardCreateUserOtpVerify";
export const SEND_NOTIFICATION = "/admin/send-notification";

export const AADHAAR_CARD_SEND_OTP_CODE = "/users/aadharcardSendOtpCodeVerify";

export const AADHARCARD_VERIFY = "/users/aadharcardVerify";
export const SAVE_MPIN_NUMBER = "/users/saveMpinNumber";
export const MPIN_NUMBER_VERIFY = "/users/mPinNumberVerify";
export const FORGET_MPIN_NUMBER = "/users/forgetMpin";
export const CHANGE_USER_STATUS = "/users/changeUserStatus";

export const SEND_REQUEST_MONEY_SAVE = "/account/sendRequestMoney";
export const SEND_COD_REQUEST_MONEY_SAVE = "/account/codSendRequestMoney";

export const CORRECT_KHATABOOK = "/account/correctKhatabook";







export const GET_ALL_MY_COD_SEND_REQUEST_MONEY = "/account/getAllMyCodSendRequest";
export const GET_ALL_MY_COD_RECEIVED_REQUEST_MONEY = "/account/getAllMyCodReceivedRequest";
export const COD_REJECT_AND_APPROVED_REQUEST = "/account/codRejectAndApproveRequest";
export const GET_ALL_MY_COD_APPROVED_REQUEST_MONEY = "/account/getCodApprovedRequestMoney";

export const POST_FUND_TOPUP_SAVE = "/account/fundTopupSave";

export const INSTANT_TOPUP_SAVE = "/account/instant-topup-save";
export const INSTANT_TOPUP_KYC_CHARGE = "/account/instant/instantKycCharge";
export const INSTANT_TOPUP_GET = "/account/instant-topup-getall";
export const INSTANT_TOPUP_APPROVE_REQUEST = "/account/postIntantPayApproveRequest";

export const FUND_REQUEST_SAVE = "/account/fund-request-save";
export const FUND_REQUEST_GET = "/account/fund-request-getall";
export const GET_ADMIN_FUND_REQUEST_REPORT = "/admin/getFundRequestReport";
export const GET_MATM_REGISTRATION_LIST = "/service/matm/getRegistrationList";
export const POST_MATM_REGISTRATION_STATUS_APPROVED = "/service/matm/matmRegisterApproved";
export const GET_MY_FUND_REQUEST_REPORT = "/users/getMyFundRequestReport";

export const BANK_DETAIL = "/users/bankdetail";
export const GET_ALL_BANK_DETAIL_INFO = "/users/getAllActivebankDetail";
export const GET_ALL_MY_SEND_REQUEST_MONEY = "/account/getAllMySendRequest";
export const GET_ALL_MY_APPROVED_REQUEST_MONEY = "/account/getApprovedRequestMoney";
export const GET_ALL_MY_RECEIVED_REQUEST_MONEY = "/account/getAllMyReceivedRequest";

export const GET_ALL_MY_SEND_PAYMENT_DEPOSIT = "/account/getAllSendPaymentDeposit";
export const GET_ALL_MY_RECEVIED_PAYMENT_DEPOSIT = "/account/getAllReceviedPaymentDeposit";
export const SAVE_PAYMENT_DEPOSIT = "/account/paymentDeposit";
export const REJECT_AND_APPROVED_REQUEST = "/account/rejectAndApproveRequest";
export const PAYMENT_DEPOSIT_REJECT_AND_APPROVED_REQUEST = "/account/paymentDepositAcceptAndReject";

export const SAVE_MOVE_TO_DISTRIBUTOR = "/account/moveToDistributor";
export const GET_ALL_MOVE_TO_DISTRIBUTOR_REPORTS = "/account/getAllMoveToDistributor";

export const ADMIN_GET_REVERSIBLE_TXN = "/account/latest-reversible-txn";
export const ADMIN_REVERSE_WALLET_TXN = "/account/reverse-wallet-txn";

export const GET_ALL_CHANNEL_WALLET_LEDGER_REPORTS = "/account/channelWalletLedger";
export const GET_MY_LEDGER_REPORTS = "/ledger/getMyLedger";
export const GET_AUTO_REPEAT_LEDGER_REPORTS = "/ledger/getMyAutoRepeatLedger";

export const GET_WALLET_TRANSFER_LEDGER_REPORTS = "/ledger/getWalletTransferLedger";
export const GET_ADMIN_WALLET_TRANSFER_LEDGER_REPORTS = "/ledger/getAdminWalletTransferLedger";


export const POST_USER_TRANSFER = "/admin/userTransfer";
export const GET_MY_CHILD_USERS = "/admin/getChildUser";
export const GET_All_OPERATOR_LIST = "/admin/getAllOperatorList";

export const PACKAGE_DETAIL_LIST = "/package/getPackageDetail";
export const PACKAGE_LIST = "/package/getAllPackages";
export const PACKAGE_SAVE = "/package/save";
export const PACKAGE_UPDATE = "/package/update";
export const PACKAGE_DELETE = "/package/delete";
export const MY_WALLET_HISTORY = "/wallet/getWalletHistory";
export const WALLET_BALANCE_LOGS_LIST = "/wallet/wallet-balance-logs";

export const GET_SERVICES = "/service";
export const GET_SERVICES_LIST = "/serviceList";
export const GET_SERVICES_OPERATOR = "/service/operator";
export const GET_SERVICES_OPERATOR_LIST = "/getServiceOperatorList";
export const GET_ALL_SERVICES_OPERATOR = "/getServiceOperator";
// Slab 
export const SLABS_NAMES = "/slab";
export const SLABS_SAVE = "/slab/save";
export const SLABS_LIST = "/slab/getAllSlab";
export const SLABS_UPDATE = "/slab/update";
export const SLABS_DELETE = "/slab/delete";

export const CHECK_CARD_TYPE = "/payu/checkCardType";
export const GET_PAYU_HASH = "/payu/getHash";

export const IFSC_CODE_VERIFY = "/upi/ifscCodeVerify";
export const GET_BANK_NAME_FROM_ACCOUNT_NUMBER_IN_BANK_SETTING = "/upi/getBankNameOfBankSetting";
export const GET_BANK_NAME_FROM_ACCOUNT_NUMBER = "/upi/getBankName";
export const GET_CUSTOMER_BANK_NAME_FROM_ACCOUNT_NUMBER = "/upi/getBeneBankNameInMobileApp";

export const SAVE_BANK_SETTING_API = "/users/bankSettingSave";
export const SET_DEFAULT_BANK_SETTING = "/users/setDefaultBankSettingSave";

export const GET_BANK_SETTING_LIST = "/users/bankSettingGetAll";
export const BANK_SETTING_CHANGE_STATUS = "/users/bankSettingChangeStatus";
export const BANK_SETTING_APMIN_APPROVE_REQUEST = "/users/bankSettingAdminApprove";
export const BANK_SETTING_DELETE = "/users/bankSetting";
export const BANK_DETAIL_UPDATE = "/users/bankdetailupdate";



export const UPI_VERIFY = "/upi/upiverify";
export const UPI_FROM_MOBILE_NUMBER = "/upi/mobileNumberGetUpi";
export const UPI_POST_TRANSACTION = "/upi/upiTransaction";

export const SEARCH_PARTNER_LEDGER_API = "/ledger/sendPartnerLedger";
export const PROFILE_PIN_MATCH_API = "/ledger/matchPinPartnerLedger";

export const POST_AEPS_LOGIN = "/aeps/aeps-login";
export const POST_AEPS_LOGIN_STATUS = "/aeps/aeps-login-status";
export const GET_AEPS_DEVICE_CONFIG = "/aeps/getAePSDeviceConfig";
export const POST_AEPS_EKYC_INITIATE = "/aeps/ekyc-initiate";
export const POST_AEPS_EKYC_VALIDATE = "/aeps/ekyc-validate";
export const POST_AEPS_BALANCE_ENQUIRY = "/aeps/balance-enquiry";
export const POST_AEPS_CASH_WITHDRAWAL = "/aeps/cash-withdrawal";
export const POST_AEPS_GENERATE_OTP = "/aeps/send-aeps-otp";
export const POST_AEPS_MINI_STATEMENT = "/aeps/min-statement";
export const GET_AEPS_BANK_LIST = "/aeps/bank-list";
export const GET_AEPS_HISTORY_LIST = "/aeps/aeps-history";
export const GET_BIO_DEVICE_LIST = "/aeps/getBioDeviceList";
export const POST_BIO_DEVICE_LIST = "/aeps/postBioDeviceList";

export const GET_INSTANTPAY_BIO_EKYC_STATUS = "/aeps/getInstantPayBioEkycStatus";
export const POST_SUBMIT_INSTANTPAY_BIO_EKYC = "/aeps/submitInstantPayBioEkyc";


export const GET_DMT_BANK_LIST = "/aeps/dmt/getBankList";
export const POST_DMT_REFRESH_SERVICE = "/aeps/dmt/refreshDMTService";
export const GET_DMT_NEW_BANK_LIST = "/aeps/dmt/getBankListNew";
export const GET_DMT_EKO_BANL_LIST = "/aeps/dmt/getEkoBankList";
export const GET_DMT_BENEFICIARY_LIST = "/aeps/dmt/getBeneficiaryList";
export const GET_DMT_IMPORT_BENEFICIARY_LIST = "/aeps/dmt/getImportBeneficiaryList";
export const GET_DMT_BENEFICIARY_DETAIL = "/aeps/dmt/getBeneficiaryDetails";
export const UPDATE_DMT_BENEFICIARY_DETAIL = "/aeps/dmt/updateBeneficiary";
export const UPDATE_DMT_BENEFICIARY_STATUS = "/aeps/dmt/activeAndDeactiveBane";
export const POST_DMT_CUSTOMER_INFO = "/aeps/dmt/getCustomerInfo";
export const POST_DMT_CREATE_CUSTOMER = "/aeps/dmt/createCustomer";
export const POST_DMT_VERIFY_CUSTOMER = "/aeps/dmt/verifyCustomerIdentity";
export const POST_DMT_FAILED_BY_PARTNER = "/aeps/dmt/markFailTransaction";
export const POST_SHOP_REGISTERD = "/aeps/postShopRegister";
export const GET_SHOP_REGISTERD = "/aeps/getShopRegister";
export const GET_SHOP_REGISTRATION_LIST = "/aeps/shopRegisterList";

export const POST_DMT_CHECK_SERVICE_TO_MOBILENUMBER = "/aeps/dmt/checkDMTServiceToMobileNumber";

// Instant Pay AIRTEL

export const GET_DMT_INSTANT_PAY_BENEFICIARY_LIST = "/service/dmt/v2/getBeneficiaryList";
export const POST_DMT_INSTANT_PAY_CUSTOMER_INFO = "/service/dmt/v2/getCustomerInfo";
export const POST_DMT_INSTANT_PAY_CREATE_CUSTOMER = "/service/dmt/v2/createCustomer";
export const POST_DMT_INSTANT_PAY_ADD_BENEFICIARY = "/service/dmt/v2/addBeneficiary";
export const POST_DMT_INSTANT_PAY_BENEFICIARY_VERIFY = "/service/dmt/v2/beneficiaryVerify";
export const POST_DMT_INSTANT_PAY_OTP_VERIFICATION = "/service/dmt/v2/customerOTPVerify";
export const POST_DMT_INSTANT_PAY_CUSTOMER_KYC = "/service/dmt/v2/customerKyc";
export const UPDATE_DMT_INSTANT_PAY_BENEFICIARY_STATUS = "/service/dmt/v2/activeAndDeactiveBane";
export const UPDATE_DMT_INSTANT_PAY_BENEFICIARY_DETAIL = "/service/dmt/v2/updateBeneficiary";
export const POST_DMT_INSTANT_PAY_INITIATE_TRANSACTION = "/service/dmt/v2/initiateTransaction";
export const POST_DMT_INSTANT_PAY_GENERATE_TRANSACTION = "/service/dmt/v2/generateTransaction";
export const POST_DMT_INSTANT_PAY_PAYMENT_TRANSFER = "/service/dmt/v2/paymentTransfer";
export const POST_DMT_INSTANT_PAY_RE_INITIATE_TRANSACTION = "/service/dmt/v2/reInitiateTransaction";
export const GET_DMT_INSTANT_PAY_TRANS_HISTORY = "/service/dmt/v2/transactionHistory";
// export const POST_DMT_INSTANT_PAY_TRANSACTION_INQUIRY = "/service/dmt/v2/getTransactionInquiry";
export const POST_DMT_INSTANT_PAY_TRANSACTION_INVOICE = "/service/dmt/v2/transactionInvoice";
export const POST_DMT_INSTANT_PAY_MERCHANT_LIST = "/service/dmt/v2/getIpayMerchantList";
export const POST_DMT_INSTANT_PAY_MERCHANT_UPDATE = "/service/dmt/v2/postIpayMobileUpdate";
export const POST_DMT_INSTANT_PAY_MERCHANT_VERIFY = "/service/dmt/v2/postIpayMobileUpdateVerify";
export const POST_DMT_INSTANT_PAY_DELETE_BENE_VERIFY = "/service/dmt/v2/deleteBeneVerify";





// Instant Pay NSDL

export const GET_DMT_NSDL_BENEFICIARY_LIST = "/service/dmt/v2_1/getBeneficiaryList";
export const POST_DMT_NSDL_CUSTOMER_INFO = "/service/dmt/v2_1/getCustomerInfo";
export const POST_DMT_NSDL_CREATE_CUSTOMER = "/service/dmt/v2_1/createCustomer";
export const POST_DMT_NSDL_ADD_BENEFICIARY = "/service/dmt/v2_1/addBeneficiary";
export const POST_DMT_NSDL_BENEFICIARY_VERIFY = "/service/dmt/v2_1/beneficiaryVerify";
export const POST_DMT_NSDL_OTP_VERIFICATION = "/service/dmt/v2_1/customerOTPVerify";
export const POST_DMT_NSDL_CUSTOMER_KYC = "/service/dmt/v2_1/customerKyc";
export const UPDATE_DMT_NSDL_BENEFICIARY_STATUS = "/service/dmt/v2_1/activeAndDeactiveBane";
export const UPDATE_DMT_NSDL_BENEFICIARY_DETAIL = "/service/dmt/v2_1/updateBeneficiary";
export const POST_DMT_NSDL_INITIATE_TRANSACTION = "/service/dmt/v2_1/initiateTransaction";
export const POST_DMT_NSDL_GENERATE_TRANSACTION = "/service/dmt/v2_1/generateTransaction";
export const POST_DMT_NSDL_PAYMENT_TRANSFER = "/service/dmt/v2_1/paymentTransfer";
export const POST_DMT_NSDL_RE_INITIATE_TRANSACTION = "/service/dmt/v2_1/reInitiateTransaction";
export const GET_DMT_NSDL_TRANS_HISTORY = "/service/dmt/v2_1/transactionHistory";
// export const POST_DMT_INSTANT_PAY_TRANSACTION_INQUIRY = "/service/dmt/v2/getTransactionInquiry";
export const POST_DMT_NSDL_TRANSACTION_INVOICE = "/service/dmt/v2_1/transactionInvoice";
export const POST_DMT_NSDL_MERCHANT_LIST = "/service/dmt/v2_1/getIpayMerchantList";
export const POST_DMT_NSDL_MERCHANT_UPDATE = "/service/dmt/v2_1/postIpayMobileUpdate";
export const POST_DMT_NSDL_MERCHANT_VERIFY = "/service/dmt/v2_1/postIpayMobileUpdateVerify";
export const POST_DMT_NSDL_DELETE_BENE_VERIFY = "/service/dmt/v2_1/deleteBeneVerify";
export const POST_DMT_NSDL_ADD_UPDATE_NSDLID = "/service/dmt/v2_1/addUpdateNSDLID";

// Instant Pay JIO

export const GET_DMT_JIO_BENEFICIARY_LIST = "/service/dmt/v2_2/getBeneficiaryList";
export const POST_DMT_JIO_CUSTOMER_INFO = "/service/dmt/v2_2/getCustomerInfo";
export const POST_DMT_JIO_CREATE_CUSTOMER = "/service/dmt/v2_2/createCustomer";
export const POST_DMT_JIO_ADD_BENEFICIARY = "/service/dmt/v2_2/addBeneficiary";
export const POST_DMT_JIO_BENEFICIARY_VERIFY = "/service/dmt/v2_2/beneficiaryVerify";
export const POST_DMT_JIO_OTP_VERIFICATION = "/service/dmt/v2_2/customerOTPVerify";
export const POST_DMT_JIO_CUSTOMER_KYC = "/service/dmt/v2_2/customerKyc";
export const UPDATE_DMT_JIO_BENEFICIARY_STATUS = "/service/dmt/v2/activeAndDeactiveBane";
export const UPDATE_DMT_JIO_BENEFICIARY_DETAIL = "/service/dmt/v2_2/updateBeneficiary";
export const POST_DMT_JIO_INITIATE_TRANSACTION = "/service/dmt/v2_2/initiateTransaction";
export const POST_DMT_JIO_GENERATE_TRANSACTION = "/service/dmt/v2_2/generateTransaction";
export const POST_DMT_JIO_PAYMENT_TRANSFER = "/service/dmt/v2_2/paymentTransfer";
export const POST_DMT_JIO_RE_INITIATE_TRANSACTION = "/service/dmt/v2_2/reInitiateTransaction";
export const GET_DMT_JIO_TRANS_HISTORY = "/service/dmt/v2_2/transactionHistory";
// export const POST_DMT_INSTANT_PAY_TRANSACTION_INQUIRY = "/service/dmt/v2/getTransactionInquiry";
export const POST_DMT_JIO_TRANSACTION_INVOICE = "/service/dmt/v2_2/transactionInvoice";
export const POST_DMT_JIO_MERCHANT_LIST = "/service/dmt/v2_2/getIpayMerchantList";
export const POST_DMT_JIO_MERCHANT_UPDATE = "/service/dmt/v2_2/postIpayMobileUpdate";
export const POST_DMT_JIO_MERCHANT_VERIFY = "/service/dmt/v2_2/postIpayMobileUpdateVerify";
export const POST_DMT_JIO_DELETE_BENE_VERIFY = "/service/dmt/v2_2/deleteBeneVerify";
export const POST_DMT_JIO_ADD_UPDATE_NSDLID = "/service/dmt/v2_2/addUpdateJIOID";
export const POST_DMT_AIRTEL_ADD_UPDATE_AIRTELID = "/service/dmt/v2_2/addUpdateAIRTELID";



export const POST_INSTANT_PAY_DELETE_BENEFICIARY = "/service/dmt/v2/deleteBene";
export const POST_INSTANT_PAY_DELETE_BENEFICIARY_VERIFY = "/service/dmt/v2/deleteBeneVerify";

export const POST_INSTANT_PAY_REFUND_OTP_REQUEST = "/service/dmt/v2/refundOtpBaseTransaction";
export const POST_INSTANT_PAY_REFUND_REQUEST = "/service/dmt/v2/refundTransaction";

export const POST_DMT_PAY_SPRINT_CUSTOMER_KYC = "/service/dmt/v3/customerKyc";
export const POST_DMT_PAY_SPRINT_CREATE_CUSTOMER = "/service/dmt/v3/createCustomer";
export const POST_DMT_PAY_SPRINT_CUSTOMER_INFO = "/service/dmt/v3/getCustomerInfo";
export const POST_DMT_PAY_SPRINT_OTP_VERIFICATION = "/service/dmt/v3/customerOTPVerify";
export const POST_DMT_PAY_SPRINT_CUSTOMER_DETAIL = "/service/dmt/v3/customerUpdateDetail";
export const GET_DMT_PAY_SPRINT_BENEFICIARY_LIST = "/service/dmt/v3/getBeneficiaryList";
export const POST_DMT_PAY_SPRINT_INITIATE_TRANSACTION = "/service/dmt/v3/initiateTransaction";
export const POST_DMT_PAY_SPRINT_GENERATE_TRANSACTION = "/service/dmt/v3/generateTransaction";
export const POST_DMT_PAY_SPRINT_PAYMENT_TRANSFER = "/service/dmt/v3/paymentTransfer";
export const POST_DMT_PAY_SPRINT_RE_INITIATE_TRANSACTION = "/service/dmt/v3/reInitiateTransaction";
export const POST_DMT_PAY_SPRINT_ADD_BENEFICIARY = "/service/dmt/v3/addBeneficiary";
export const UPDATE_DMT_PAY_SPRINT_BENEFICIARY_STATUS = "/service/dmt/v3/activeAndDeactiveBane";
export const UPDATE_DMT_PAY_SPRINT_BENEFICIARY_DETAIL = "/service/dmt/v3/updateBeneficiary";
export const DELETE_DMT_PAY_SPRINT_BENEFICIARY = "/service/dmt/v3/deleteBene";
// export const POST_DMT_PAY_SPRINT_TRANSACTION_INQUIRY = "/service/dmt/v3/getTransactionInquiry";

export const POST_DMT_PAY_SPRINT_CONFIRM_INITIATE_TRANSACTION = "/service/dmt/v3/confirmInitiateTransaction";

export const POST_PAY_SPRINT_REFUND_OTP_REQUEST = "/service/dmt/v3/refundOtpBaseTransaction";
export const POST_PAY_SPRINT_REFUND_REQUEST = "/service/dmt/v3/refundTransaction";

export const POST_PAYOUT_V2_ADD_BENEFICIARY = "/payment/payout/v2/addBeneficiary";
export const POST_PAYOUT_V2_ADD_MOVE_TO_BANK_BENEFICIARY = "/payment/payout/v2/addMoveToBankBeneficiary";


export const POST_PAYOUT_V2_PAYMENT_TRANSFER = "/payment/payout/v2/payoutPaymentTransaction";

export const POST_PAYOUT_CHECK_BENEFICIARY = "/payment/payout/checkBenificiary";

export const POST_PAYOUT_CHECK_EXIST_CUSTOMER_DETAIL = "/payment/payout/checkExistPayoutCustomer";
export const POST_PAYOUT_ADD_CUSTOMER_DETAIL = "/payment/payout/addCustomer";
export const POST_PAYOUT_CUSTOMER_DETAIL = "/payment/payout/getCustomerDetail";
export const POST_PAYOUT_ADD_BENEFICIARY = "/payment/payout/addBeneficiary";
export const POST_PAYOUT_GET_BENEFICIARY = "/payment/payout/getBeneficiaryList";
export const POST_PAYOUT_UPDATE_BENEFICIARY_DETAIL = "/payment/payout/updateBeneficiary";
export const POST_PAYOUT_UPDATE_STATUS_BENEFICIARY = "/payment/payout/activeAndDeactiveBane";
export const POST_PAYOUT_INITIATED_TRANSACTION = "/payment/payout/payoutTransactionInitiated";
export const POST_PAYOUT_PAYMENT_TRANSFER = "/payment/payout/payoutPaymentTransaction";
export const POST_PAYOUT_GET_TRANSACTION_HISTORY = "/payment/payout/transactionHistory";
export const POST_PAYOUT_ADMIN_GET_TRANSACTION_HISTORY = "/payment/payout/getMoneyTransferReport";
export const POST_PAYOUT_ADMIN_GET_TRANSACTION_FAILED_HISTORY = "/payment/payout/getFailTransactionHistory";
export const POST_PAYOUT_GET_TRANSACTION_INQUIRY = "/payment/payout/getTransactionInquiry";
export const POST_PAYOUT_REFUND_FAILED_TRANSACTION = "/payment/payout/refundFailTransaction";
export const POST_PAYOUT_TRANSACTION_INVOICE = "/payment/payout/transactionInvoice";
export const POST_PAYOUT_MARK_FAIL_TRANSACTION = "/payment/payout/postFailTransaction";

export const POST_AEPS_EKYC_EKO_STEP_1 = "/aeps/apesEkycEkoStep1";
export const POST_AEPS_EKYC_EKO_STEP_2 = "/aeps/apesEkycEkoStep2";
export const POST_AEPS_EKYC_EKO_STEP_3 = "/aeps/apesEkycEkoStep3";
export const POST_AEPS_EKYC_EKO_STEP_4 = "/aeps/apesEkycEkoStep4";
export const POST_AEPS_EKYC_EKO_STEP_5 = "/aeps/apesEkycEkoStep5";
export const POST_AEPS_EKYC_EKO_STEP_6 = "/aeps/apesEkycEkoStep6";
export const POST_AEPS_SHOP_CONTROL_STATUS = "/aeps/shopControlStatus";


export const GET_ADDRESS_FROM_LAT_LONG = "/aeps/getAddressFromLatLong";
export const POST_DMT_ADD_BENEFICIARY = "/aeps/dmt/addBeneficiary";
export const GET_DMT_TRANS_HISTORY = "/aeps/dmt/transactionHistory";
export const POST_DMT_INITIATE_TRANSACTION = "/aeps/dmt/initiateTransaction";
export const GET_SYNC_BENEFICIARY_LIST = "/aeps/dmt/syncBeneficiaryList";
export const POST_DMT_REINITIATE_TRANSACTION = "/aeps/dmt/reInitiateTransaction";
export const GET_DMT_TRANSACTION_INQUIRY = "/aeps/dmt/getTransactionInquiry";
export const POST_DMT_REFUND_TRANSACTION = "/aeps/dmt/refundTransaction";
export const POST_DMT_REFUND_OTP_REQUEST_TRANSACTION = "/aeps/dmt/refundOtpBaseTransaction";
export const POST_DMT_TRANSACTION_INVOICE = "/aeps/dmt/transactionInvoice";
export const POST_FINO_TRANSACTION_INVOICE = "/aeps/dmt/finoTransactionInvoice";

export const POST_EKO_FIND_BANK_DETAIL = "/aeps/dmt/getBankInfoFromShortCode";
export const GET_DMT_TRANSACTION_FAILED = "/aeps/dmt/getFailTransactionHistory";
export const GET_DMT_TRANSACTION_REFUNDED = "/aeps/dmt/getRefundedTransactionHistory";
export const GET_DMT_TRANSACTION_DETAIL_HISTORY = "/aeps/dmt/getDmtTransactionDetailHistory";
export const GET_DMT_TRANSACTION_DETAIL_REPORT = "/aeps/dmt/getDmtTransactionDetailReport";

export const POST_DMT_REFUND_FAILED_TRANSACTION = "/aeps/dmt/refundFailTransaction";
export const GET_DMT_PARTNER_REFUND_PENDING_HISTORY = "/aeps/dmt/getDmtPartnerRefundPendingHistory";
export const POST_DMT_TRANSACTION_UPDATE = "/aeps/dmt/transactionUpdate";

export const POST_DMT_FAIL_TRANSACTION = "/aeps/dmt/postFailTransaction";
export const GET_DMT_TRANS_REPORT = "/admin/getMoneyTransferReport";
export const GET_AEPS_WITHDRAWAL_REPORT = "/admin/getAePSWithdrawalReport";
export const GET_AEPS_WITHDRAWAL_INQUIRY = "/aeps/getTransactionInquiry";
// export const GET_AEPS_3WAYRECON_REPORT = "https://api.ledger.srpay1.com/admin/getAeps3WayReport";
export const GET_AEPS_3WAYRECON_REPORT = "https://apiledger.srpay1.com/admin/getAeps3WayReport";

export const GET_ADMIN_MOBILE_RECHARGE_REPORT = "/admin/getMobileRechargeReport";
export const GET_ADMIN_DTH_RECHARGE_REPORT = "/admin/getDthRechargeReport";
export const GET_ADMIN_COMMISSION_TRANSACTION_REPORT = "/admin/getCommissionTransactionReport";
export const GET_ADMIN_INSTANT_STATEMENT_REPORT = "/admin/getInstantStatementReport";

export const GET_COMMISSION_LIST = "/users/getCommissionList";
export const SAVE_COMPLAINT = "/complaint/save";
export const GET_CLIENT_COMPLAINT_LIST = "/complaint/getAllClient";
export const GET_ADMIN_COMPLAINT_LIST = "/complaint/getAllAdmin";
export const PUT_UPDATE_COMPLAINT_LIST = "/complaint/update";

export const GET_USER_MONTHLY_COMMISSION_CALCULATE = "/users/monthlyCommissionCalculate";
export const POST_SAVE_COMMISSION_WITHDRAWAL = "/users/commissionWithdrawal";
export const GET_COMMISSION_WITHDRAWAL_HISTORY = "/users/getCommissionWithdrawalHistoryList";
export const POST_INSTANT_REKYC_API = "/users/instantReKyc";

export const FING_PAY_ONBOARDING = "/fing/onboarding";
export const FING_PAY_CHECK_EKYC_STATUS = "/fing/getKycStatus";
export const FING_PAY_CHECK_EKYC_SEND_OTP = "/fing/eKycSendOtp";
export const FING_PAY_CHECK_EKYC_RESEND_OTP = "/fing/eKycResendOtp";
export const FING_PAY_CHECK_EKYC_SEND_OTP_VERIFY = "/fing/eKycSendOtpVerify";
export const FING_PAY_CHECK_EKYC_BIOMETRIC_REQUEST = "/fing/eKycBiometricLogin";
export const FING_PAY_2FA_BIOMETRIC_REQUEST = "/fing/twoFABiometricLogin";
export const FING_PAY_KYC_STATUS_CHANGED = "/fing/changeKycStatus";
export const FINO_USER_STATUS_CHANGED = "/fino/changeKycStatus";
export const FING_PAY_BANK_LIST = "/fing/getBanklist";
export const FING_PAY_BALANCE_ENQUIRY_API = "/fing/balanceEnquiry";
export const FING_PAY_GENERATE_OTP = "/fing/sendAepsTxnOtp";
export const FING_PAY_CASH_WITHDRAWAL_API = "/fing/cashWithDrawal";
export const FING_PAY_CASH_WITHDRAWAL_CHECK_STATUS_API = "/fing/cashWithDrawalCheckStatus";


export const FING_PAY_ADHAR_PAY_API = "/fing/aadharPay";
export const FING_PAY_CASH_DEPOSIT_API = "/fing/cashDeposit";
export const FING_PAY_CASH_DEPOSIT_STATUS_API = "/fing/cashDepositStatusCheck";

export const AEPS_REGISTER_DOWNLOAD_HISTORY = "/fing/getAepsRegisterHistory";
export const AEPS_REGISTER_DOWNLOAD_ZIP = "/fing/aepsRegisterDownload";
export const AEPS_REGISTER_SAVE = "/fing/aepsRegister";
// export const TRANSACTION_LOG_HISTORY = "https://api.ledger.srpay1.com/transaction/getLogHistory";
export const TRANSACTION_LOG_HISTORY = "https://apiledger.srpay1.com/transaction/getLogHistory";

export const GET_UPI_LOAD_MONEY_REPORT = "/upi/getUpiLoadMoneyReport";
// export const POST_SETTLEMENT_TO_BANK_SAVE = "/payment/settlement/postSettleToBankTransaction";
export const POST_SETTLEMENT_TO_BANK_STATUS = "/payment/settlement/settelToBankTransactionStatus";
export const POST_SETTLEMENT_TO_BANK_PAYMENT_TRANSACTION = "/payment/settlement/settlementToBankPaymentTransaction";
export const GET_SETTLEMENT_TO_BANK_ADMIN_HISTORY = "/payment/settlement/getSettlementToBankAdminReport";
export const GET_SETTLEMENT_TO_BANK_PARTNER_HISTORY = "/payment/settlement/getSettlementToBankPartnerReport";


export const QR_CODE_CHECK_CALLBACK_API = "/upi/qrcode/checkCallbackTransaction";
export const SAVE_QR_CODE_MINI = "/upi/qrcode/generateTransactionMini";
export const SAVE_QR_CODE_MINI_CHANGE_STATUS = "/upi/qrcode/generateQRMiniStatus";
export const GET_QR_CODE_MINI_REPORT = "/upi/qrcode/getGenerateTransactionMiniReport";

export const POST_UPI_TRANSFER_CUSTOMER_INFO = "/upi/transfer/getCustomerInfo";
export const POST_UPI_TRANSFER_ADD_CUSTOMER = "/upi/transfer/addCustomer";
export const GET_UPI_TRANSFER_BENEFICIARY_LIST = "/upi/transfer/getBeneficiaryList";
export const POST_UPI_TRANSFER_SYNC_BENEFICIARY_LIST = "/upi/transfer/syncVPABeneficiary";
export const POST_UPI_TRANSFER_CHANGE_BENEFICIARY_STATUS = "/upi/transfer/activeAndDeactiveBane";
export const POST_SEND_MATM_OFFER_API = "/admin/sendMATMOffer";
export const POST_MATM_REGISTRATION_API = "/service/matm/saveMatmRegistration";
export const GET_MATM_MY_REGISTRATION_API = "/service/matm/getMyRegistration";
export const DELETE_MATM_REGISTRATION_API = "/service/matm/deleteRegistration";
export const GET_TRANSACTION_REPORT_API = "/service/matm/getTransactionReport";
export const GET_MATM_ORDER_LIST_API = "/service/matm/getMATMOrderList";
export const POST_MATM_ORDER_STATUS_API = "/service/matm/matmOrderStatusApproved";
export const POST_AEPS_MONTHLY_COMMISSION = "/aeps/dmt/monthlyDmtCommissionCronJob";

export const GET_ADVERTISEMENT_LIST_API = "/admin/advertisement/getAdvertisementList";
export const POST_ADVERTISEMENT_LIST_API = "/admin/advertisement/addAndEditAdvertisement";
export const GET_PAYOUT_SERVICE_LIST_API = "/payment/payout/getPayoutServiceAPI";
export const POST_BENE_BANK_ACCOUNT_LIMIT = "/payment/payout/getBeneAccountLimit";

export const GET_RESERVE_TRANSACTION_LIST_API = "/admin/getReserveTransaction";
export const POST_RESERVE_TRANSACTION_API = "/admin/postReserveTransaction";
export const POST_TRANSFER_TO_WALLET = "/admin/transferToWallet";

export const GET_DMT_DUPLICATE_TRANS_REPORT = "/admin/getDuplicateMoneyTransferReport";
export const GET_DUPLICATE_TRANSACTION_REPORT_API = "/service/matm/getDuplicateTransactionReport";
export const GET_AEPS_DUPLICATE_WITHDRAWAL_REPORT = "/admin/getAePSDuplicateWithdrawalReport";
export const GET_ADMIN_MOBILE_RECHARGE_DUPLICATE_REPORT = "/admin/getMobileRechargeDuplicateReport";
export const GET_ADMIN_DTH_RECHARGE_DUPLICATE_REPORT = "/admin/getDthRechargeDuplicateReport";


// Fino Onboarding
export const FINO_ONBOARDING = "/fino/onboarding";
export const FINO_CHECK_STATUS = "/fino/onboarding-status";
export const FINO_CHECK_KYC_STATUS = "/fino/kyc-status";
export const FINO_MERCHANT_ACTIVATION_URL = "/fino/merchant-activation";
export const FINO_QUERY_REMITTER = "/fino/query-remitter";

//FINO ADD BENEFICIARY
export const POST_FINO_ADD_BENEFICIARY = "/fino/add-beneficiary";
export const POST_FINO_ADD_BENEFICIARY_OTP = "/fino/add-beneficiary-send-otp";
export const GET_FINO_BENEFICIARY_LIST = "/fino/getBeneficiaryList";
export const POST_FINO_CONFIRM_INITIATE_TRANSACTION = "/fino/fino-confirm-initiate-transaction";
export const POST_FINO_SEND_OTP_TRANSACTION = "/fino/send-transaction-otp";
export const POST_FINO_MAKE_TRANSACTION = "/fino/make-transaction";
export const POST_FINO_SEND_REFUND_OTP = "/fino/send-refund-otp";
export const POST_FINO_CLAIM_REFUND = "/fino/claim-refund";
export const POST_FINO_TRANSACTION_ENQUIRY = "/fino/transaction-enquiry";
export const POST_FINO_DELETE_BENEFICIARY = "/fino/delete-beneficiary";
export const POST_FINO_ADD_FINO_MERCHANT = "/fino/fino-update-merchant-id";

//DIGILOCKER Verification
export const DIGILOCKER_VERIFY = "/users/digilockerVerify";
export const CREATE_DIGILOCKER_URL = "/users/createDigiLockerUrl";
export const GET_VERIFICATION_STATUS = "/users/getVerificationStatus";
export const GET_DOCUMENT_DATA = "/users/getDocumentData";



//Payout Maker Requst
export const ADMIN_FUND_PAYOUTMAKER = "/api/uploadexcelData";



//Bank Management

export const GET_ALL_BANKS = '/admin/banks/getAllBanks';
export const SEARCH_BANK_BY_IFSC = '/admin/banks/searchBankByIFSC';
export const FILTER_BANK_BY_KEY = '/admin/banks/filterBankByKey';
export const GET_UNIQUE_KEYS = '/admin/banks/getUniqueKeys';
export const GET_BANK_BY_ID = (id) => `/admin/banks/getBankById/${id}`;
export const SAVE_BANK = '/admin/banks/saveBank';
export const UPDATE_BANK = (id) => `/admin/banks/updateBank/${id}`;
export const REMOVE_BANK = (id) => `/admin/banks/removeBank/${id}`;

export const EXPORT_BANKS = '/admin/banks/exportBanks';
export const BULK_IMPORT_BANKS = '/admin/banks/bulkImport';


//INSTANT PAY OUTLET ID MANAGEMENT
export const SAVE_OUTLET_ID = "/admin/saveOutletId";
export const LIST_OUTLET_ID = "/admin/listOutletIds";
export const DELETE_OUTLET_ID = "/admin/deleteOutletId";
export const BULK_OUTLET_UPLOAD = "/admin/bulkOutletUpload";
export const EXPORT_OUTLET_ID = "/admin/exportOutletIds";



// KHATABOOK APIs

// ================================
// KHATABOOK MODULE CONSTANTS
// ================================

// Party/Customer APIs
export const SAVE_PARTY = '/khatabook/party';
export const LIST_PARTY = '/khatabook/party';
export const GET_PARTY = '/khatabook/party';
export const UPDATE_PARTY = '/khatabook/party';
export const DELETE_PARTY = '/khatabook/party';

// Ledger/Transaction APIs
export const CREATE_LEDGER_ENTRY = '/khatabook/ledger/entry';
export const GET_LEDGER = '/khatabook/ledger';
export const GET_LEDGER_ENTRY = '/khatabook/ledger/entry';
export const UPDATE_LEDGER_ENTRY = '/khatabook/ledger/entry';
export const DELETE_LEDGER_ENTRY = '/khatabook/ledger/entry';

// Dashboard & Statistics
export const GET_DASHBOARD_STATS = '/khatabook/dashboard/stats';

// Search APIs
export const SEARCH_PARTIES = '/khatabook/search/parties';
export const SEARCH_TRANSACTIONS = '/khatabook/search/transactions';

// Bulk Operations
export const BULK_IMPORT_PARTIES = '/khatabook/bulk/parties';
export const BULK_IMPORT_TRANSACTIONS = '/khatabook/bulk/transactions';

// Export APIs
export const EXPORT_PARTIES_EXCEL = '/khatabook/export/parties/excel';
export const EXPORT_LEDGER_EXCEL = '/khatabook/export/ledger';
export const EXPORT_LEDGER_PDF = '/khatabook/export/ledger';

// Report APIs
export const GENERATE_PARTY_REPORT = '/khatabook/report/party';
export const GET_SUMMARY_REPORT = '/khatabook/report/summary';

// Settings APIs
export const GET_KHATABOOK_SETTINGS = '/khatabook/settings';
export const UPDATE_KHATABOOK_SETTINGS = '/khatabook/settings';

// Notification APIs
export const SEND_WHATSAPP_REMINDER = '/khatabook/notification/whatsapp';
export const SEND_SMS_REMINDER = '/khatabook/notification/sms';

// Analytics APIs
export const GET_OVERVIEW_ANALYTICS = '/khatabook/analytics/overview';
export const GET_PARTY_ANALYTICS = '/khatabook/analytics/party';
export const GET_ALL_TRANSACTIONS = '/khatabook/transactions/all';


export const BBPS_CATEGORIES_CC = "/bbps/biller-categories";

export const BILLERS_API = "/bbps/billers";
export const FETCH_BILL_API = + "/bbps/fetch_bill";
export const FETCH_CREDIT_CARD_BILL_API = + "/bbps/fetch_credit_card_bill";
export const PAY_BILL_API = "/bbps/pay_bill";

//BBPS IMW V1
// export const  BBPS_IMWALLET_OPERATORS = "/bbps-im-wallet/operators";
// export const  BBPS_IMWALLET_FETCH_BILL = "/bbps-im-wallet/fetch-bill";
// export const  BBPS_IMWALLET_PAY_BILL = "/bbps-im-wallet/pay-bill";
// export const  BBPS_IMWALLET_EXTRA_PARAMS = "/bbps-im-wallet/extra-params";
// export const  BBPS_IMWALLET_CHECK_STATUS = "/bbps-im-wallet/check-status";

// export const BBPS_IMWALLET_TRANSACTION_HISTORY = '/bbps-im-wallet/transaction-history';
// export const BBPS_IMWALLET_TRANSACTION_STATUS = '/bbps-im-wallet/check-status';
// export const BBPS_IMWALLET_ADMIN_TRANSACTION_HISTORY = '/bbps-im-wallet/admin-im-wallet-transaction-history';

// export const BBPS_COMPLAINT_SUBMIT = '/bbps-im-wallet/submit-complaint';
// export const BBPS_COMPLAINT_HISTORY = '/bbps-im-wallet/complaint-history';
// export const BBPS_COMPLAINT_STATUS = '/bbps-im-wallet/complaint-status';
// export const PAY_RECHARGE = '/bbps-im-wallet/pay-recharge';


// ==================== BBPS V2 (Bharat Connect API 2.0) ====================
// All endpoints now point to the V2 backend routes
export const BBPS_IMWALLET_CATEGORIES = "/bbps-im-wallet2/categories";
export const BBPS_IMWALLET_OPERATORS = "/bbps-im-wallet2/operators";
export const BBPS_IMWALLET_FETCH_BILL = "/bbps-im-wallet2/fetch-bill";
export const BBPS_IMWALLET_PAY_BILL = "/bbps-im-wallet2/pay-bill";
export const BBPS_IMWALLET_EXTRA_PARAMS = "/bbps-im-wallet2/extra-params";
export const BBPS_IMWALLET_CHECK_STATUS = "/bbps-im-wallet2/check-status";

export const BBPS_IMWALLET_TRANSACTION_HISTORY = '/bbps-im-wallet/transaction-history';
export const BBPS_IMWALLET_TRANSACTION_STATUS = '/bbps-im-wallet/check-status';
export const BBPS_IMWALLET_ADMIN_TRANSACTION_HISTORY = '/bbps-im-wallet/admin-im-wallet-transaction-history';

export const BBPS_COMPLAINT_SUBMIT = '/bbps-im-wallet2/submit-complaint';
export const BBPS_COMPLAINT_HISTORY = '/bbps-im-wallet2/complaint-history';
export const BBPS_COMPLAINT_STATUS = '/bbps-im-wallet2/complaint-status';

// Recharge endpoint (not part of BBPS V2, keep as is)
export const PAY_RECHARGE = '/bbps-im-wallet/pay-recharge';   // unchanged

// LIC BBPS Constants
export const LIC_FETCH_BILL = '/bbps-im-wallet/fetchLicBill';
export const LIC_PAY_BILL = '/bbps-im-wallet/payLicBill';

// InstantPay BBPS APIs
export const INSTANTPAY_CATEGORIES = '/bbps-ip/categories';
export const INSTANTPAY_BILLERS = '/bbps-ip/billers';
export const INSTANTPAY_BILLER_DETAILS = '/bbps-ip/biller-details';
export const INSTANTPAY_PRE_PAYMENT_ENQUIRY = '/bbps-ip/pre-payment-enquiry';
export const INSTANTPAY_MAKE_PAYMENT = '/bbps-ip/make-payment';

export const GET_UPI_ATM_TRANSACTION_HISTORY = 'upi/instantpayatm/transaction-history';
export const GET_UPI_ATM_TRANSACTION_DETAIL = 'upi/instantpayatm/transaction-detail';
export const UPI_ATM_CHECK_STATUS_REPORT = 'upi/instantpayatm/checkStatus';
export const UPI_ATM_CHECK_STATUS = 'upi/instantpayatm/checkStatus';
export const GET_UPI_ATM_ADMIN_REPORT = 'admin/upi-atm-withdrawal-report';


export const UPDATE_UPI_QR_OUTLET_ID = 'upi/instantpayatm/updateUpiOutletId';


// ============================================
// FINO IMW DMT - Frontend API Endpoints
// ============================================

// Registration Flow
export const FINO_IMW_CHECK_SENDER = "/fino2/check-sender";
export const FINO_IMW_SENDER_EKYC = "/fino2/sender-ekyc";
export const FINO_IMW_GET_SENDER_REG_OTP = "/fino2/get-sender-reg-otp";
export const FINO_IMW_SENDER_REGISTRATION = "/fino2/sender-registration";
export const FINO_IMW_COMPLETE_REGISTRATION = "/fino2/complete-registration";
export const FINO_IMW_GET_SENDER_LIMIT = "/fino2/get-sender-limit";

// Transaction Flow
export const FINO_IMW_GET_TRANSACTION_OTP = "/fino2/get-transaction-otp";
export const FINO_IMW_SEND_MONEY = "/fino2/send-money";
export const FINO_IMW_TRANSACTION_INQUIRY = "/fino2/transaction-inquiry";

// Beneficiary Management
export const FINO_IMW_ADD_BENEFICIARY = "/fino2/add-beneficiary";
export const FINO_IMW_GET_BENEFICIARY_LIST = "/fino2/get-beneficiary-list";
export const FINO_IMW_DELETE_BENEFICIARY = "/fino2/delete-beneficiary";
export const FINO_IMW_UPDATE_BENEFICIARY = "/fino2/update-beneficiary";

// Transaction History
export const FINO_IMW_GET_TRANSACTION_HISTORY = "/fino2/transaction-history";
export const FINO_IMW_GET_TRANSACTION_DETAIL = "/fino2/transaction-detail";
export const FINO_IMW_GET_TRANSACTION_INVOICE = "/fino2/transaction-invoice";

// Admin
export const FINO_IMW_ADD_OR_UPDATE_OUTLET_ID = "/fino2/add-or-update-fino-id";
export const FINO_IMW_CONFIRM_INITIATE = '/fino2/confirm-initiate';
export const FINO_IMW_INITIATE = '/fino2/initiate';
export const FINO_IMW_GENERATE = '/fino2/generate';
export const FINO_IMW_PAYMENT_TRANSFER = '/fino2/payment-transfer';
export const FINO_IMW_CANCEL = '/fino2/cancel';

// ============================================
// AIRTEL IMW DMT - Frontend API Endpoints
// ============================================

// Registration Flow
export const AIRTEL_IMW_CHECK_SENDER = "/airtelImw/check-sender";
export const AIRTEL_IMW_GET_SENDER_REG_OTP = "/airtelImw/get-sender-reg-otp";
export const AIRTEL_IMW_SENDER_REGISTRATION = "/airtelImw/validate-otp";
export const AIRTEL_IMW_VALIDATE_OTP = "/airtelImw/validate-otp";
export const AIRTEL_IMW_SENDER_EKYC = "/airtelImw/kyc";

// Transaction Flow
export const AIRTEL_IMW_CONFIRM_INITIATE = "/airtelImw/confirm-initiate";
export const AIRTEL_IMW_GET_TRANSACTION_OTP = "/airtelImw/get-transaction-otp";
export const AIRTEL_IMW_PAYMENT_TRANSFER = "/airtelImw/payment-transfer";
export const AIRTEL_IMW_TRANSACTION_INQUIRY = "/airtelImw/transaction-inquiry";
export const AIRTEL_IMW_CANCEL_TRANSACTION = "/airtelImw/cancel-transaction";

export const AIRTEL_IMW_GENERATE = '/airtelImw/generate';


// Beneficiary Management
export const AIRTEL_IMW_ADD_BENEFICIARY = "/fino2/add-beneficiary";
export const AIRTEL_IMW_GET_BENEFICIARY_LIST = "/fino2/get-beneficiary-list";
export const AIRTEL_IMW_DELETE_BENEFICIARY = "";
export const AIRTEL_IMW_GET_SENDER_LIMIT = "airtelImw/check-sender";
export const AIRTEL_IMW_INITIATE = '/airtelImw/initiate';




// Transaction History (optional – can reuse existing history endpoints if they filter by apiName)
export const AIRTEL_IMW_GET_TRANSACTION_HISTORY = "/airtelImw/transaction-history";
export const AIRTEL_IMW_GET_TRANSACTION_DETAIL = "/airtelImw/transaction-detail";



// Fund Transfer
export const POST_SETTLEMENT_TO_BANK_SAVE = '/fund-transfer/request';
export const POST_FUND_TRANSFER_REQUEST = '/fund-transfer/request';
export const GET_FUND_TRANSFER_CHECKER_LIST = '/fund-transfer/checker/list';
export const POST_FUND_TRANSFER_CHECKER_BULK_ACTION = '/fund-transfer/checker/bulk-action';
export const GET_FUND_TRANSFER_MAKER_LIST = '/fund-transfer/maker/list';
export const POST_FUND_TRANSFER_MAKER_BULK_ACTION = '/fund-transfer/maker/bulk-action';
export const POST_FUND_TRANSFER_MANUAL_REFUND = '/fund-transfer/manual-refund';
export const POST_FUND_TRANSFER_BULK_REFUND = '/fund-transfer/bulk-refund';
export const GET_FUND_TRANSFER_REQUEST_DETAILS = '/fund-transfer/request';
export const GET_FUND_TRANSFER_ADMIN_LIST = '/fund-transfer/admin-fund-transfer-report';
export const GET_FUND_TRANSFER_FAILED_LIST = '/fund-transfer/admin/failed-report';
export const GET_FUND_TRANSFER_USER_LIST = '/fund-transfer/user-report';
export const POST_FUND_TRANSFER_CUSTOMER_DETAILS = '/fund-transfer/customer-detail';
export const POST_FUND_TRANSFER_ADD_BENEFICIARY = '/fund-transfer/add-beneficiary';
export const POST_FUND_TRANSFER_ADD_CUSTOMER = '/fund-transfer/add-customer';
export const POST_FUND_TRANSFER_UPDATE_STATUS = '/fund-transfer/update-status';
export const POST_FUND_TRANSFER_MARK_FAILED = '/fund-transfer/mark-failed';
export const GET_BATCH_TRANSACTIONS_REPORT = '/fund-transfer/get-batch-transactions';
export const POST_FUND_TRANSFER_INVOICE = '/fund-transfer/invoice';

//User Permission
export const USER_PERMISSION_SCHEMA = "/userPermission/schema";
export const USER_PERMISSION_GET = "/userPermission/get";
export const USER_PERMISSION_SAVE = "/userPermission/save";
export const USER_PERMISSION_MY = "/userPermission/my";
export const USER_PERMISSION_BATCH ='/userPermission/batch'
export const FING_UPI_CW_CHECK_STATUS = '/fing/upi-cw/check-status';


export const POST_SEED_SHADOW = '/admin/seedShadow';
export const UPI_PAYOUT_ADMIN_LIST  = 'upi-payout/admin/requests';
export const UPI_PAYOUT_ADMIN_STATS = 'upi-payout/admin/stats';